import { Layout, ConnectionQualitySystem } from "components"
export const ConnectionQuality = () => {
 return (
  <Layout>
   <ConnectionQualitySystem />
  </Layout>
 )
}
